import { DubsHeader, DubsSubHeader, MainTextContainer } from '../../Global/StaticElements';

export default function Failure() {
    return(
        <MainTextContainer>
          <DubsHeader>Something went wrong...</DubsHeader>
          <DubsSubHeader>Please try again</DubsSubHeader>
        </MainTextContainer>
      )
}